import Rate from './src/index.vue'

export default Rate
